/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PostList = {
    type: 'array',
    contains: {
        type: 'Post',
    },
} as const;
